import React from "react";
import { motion, AnimatePresence } from "framer-motion";

import { BrigadeFull } from "../../types/brigade";
import { BrigadeItem } from '../BrigadeItem';

type Props = {
  brigades: BrigadeFull[];
};

export const BrigadesList: React.FC<Props> = ({ brigades }) => {
  return (
    <AnimatePresence initial={false}>
      {brigades.map((brigade) => (
        <motion.li
          key={brigade.id}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          layoutId={brigade.id.toString()}
          transition={{ duration: 0.5 }}
        >
          <BrigadeItem brigade={brigade} />
        </motion.li>
      ))}
    </AnimatePresence>
  );
};
